<template>
  <div class="slider-menu">
    <a
      v-show="!isShow"
      data-stat="会场侧边导航-打开"
      href="javascript:void(0);"
      class="box-fr"
      @click="navClick(true)"
    ></a>
    <div
      class="fr-nav"
      :class="isShow?'fr-navshoe':''"
      @click.prevent="navClick(false)"
      data-stat="会场侧边导航-关闭"
    >
      <div class="fr-nav-box">
        <div class="fr-nav-con" :class="isShow?'fr-nav-conshow':''">
          <div class="fr-nav-nav">
            <a
              data-stat="会场侧边导航-天天签到"
              href="javascript:void(0);"
              @click.stop="toMoudle('1')"
              class="fr-nav-but"
            >天天签到 &gt;</a>
            <!-- <a
              data-stat="会会场侧边导航-超级返利"
              href="javascript:void(0);"
              @click.stop="toMoudle('2')"
              class="fr-nav-but"
            >超级返利 &gt;</a>-->
            <a
              data-stat="会场侧边导航-丰收品类"
              href="javascript:void(0);"
              class="fr-nav-but"
              @click.stop="showList('0')"
            >丰收品类</a>
            <ul class="clearfix pinl" v-show="showType">
              <li v-for="(item,i) in goodsArr" :key="i">
                <a
                  href="javascript:void(0)"
                  @click="toOther(item.href)"
                  :data-stat="`会场侧边导航-${item.listingName}`"
                >{{item.name}}</a>
              </li>
            </ul>
            <a
              data-stat="会场侧边导航-丰收地区"
              href="javascript:void(0);"
              class="fr-nav-but"
              @click.stop="showList('1')"
              v-show="type==1"
            >丰收地区</a>
            <ul class="diqu clearfix" v-show="type==1&&showArea">
              <li v-for="(item,i) in areaArr" :key="i">
                <a
                  href="javascript:void(0)"
                  @click="toOther(item.href)"
                  :data-stat="`会场侧边导航-${item.listingName}`"
                >{{item.name}}</a>
              </li>
            </ul>
          </div>
          <h5></h5>
          <i></i>
          <a
            href="javascript:void(0);"
            class="shoufr"
            @click.stop="navClick(false)"
            data-stat="会场侧边导航-关闭"
          ></a>
        </div>
      </div>
    </div>
  </div>
</template>  

<script>
import Vue from "vue";
export default {
  props: ["type"],
  data() {
    return {
      isShow: false, //展示右侧菜单
      showArea: false, //地区展示
      showType: true, //品类展示
      goodsArr: [],
      goodsArr1: [
        {
          name: "扶贫专区",
          href: "https://www.ule.com/ulenp/event/2019/0919/wap.html"
        },
        {
          name: "饕餮美食",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=248"
        },
        {
          name: "品质家居",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=245"
        },
        {
          name: "美妆尖货",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=246"
        },
        {
          name: "数码家电",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=247"
        },
        {
          name: "风尚穿搭",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=243"
        },
        {
          name: "海外优选",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=244"
        },
        {
          name: "邮品专区",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=250"
        },
        {
          name: "邮储银行专区",
          href:
            "https://www.ule.com/event/2019/0813/H5.html?adid=psbc_yl_appzhc"
        },
        {
          name: "绿色生活 绿色发展",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=251"
        }
      ],
      goodsArr2: [
        {
          name: "惠农优选",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=261"
        },
        {
          name: "饕餮美食",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=248"
        },
        {
          name: "品质家居",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=245"
        },
        {
          name: "美妆尖货",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=246"
        },
        {
          name: "数码家电",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=247"
        },
        {
          name: "风尚穿搭",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=243"
        },
        {
          name: "海外优选",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=244"
        },
        {
          name: "邮储银行",
          href: "https://www.ule.com/event/2019/0812/H5.html"
        },
        {
          name: "绿色生活 绿色发展",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=251"
        }
      ],
      areaArr: [
        {
          name: "华东",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=306"
        },
        {
          name: "华中",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=307"
        },
        {
          name: "西南",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=308"
        },
        {
          name: "东北",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=309"
        },
        {
          name: "华南",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=311"
        },
        {
          name: "华北",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=310"
        },
        {
          name: "西北",
          href: "https://www.ule.com/event/tmpl/ulewap.html?actId=312"
        }
      ]
    };
  },
  created() {
    if (this.type == 0) {
      this.goodsArr = this.goodsArr2;
    } else if (this.type == 1) {
      this.goodsArr = this.goodsArr1;
    }
  },
  methods: {
    toOther(link) {
      location.href = link;
    },
    navClick(val) {
      this.isShow = val;
    },
    showList(type) {
      if (type == "0") {
        this.showType = true;
        this.showArea = false;
      } else if (type == "1") {
        this.showType = false;
        this.showArea = true;
      }
    },
    toMoudle(type) {
      this.isShow = false;
      var dom;
      if (this.type == 0) {
        //预热页面
        dom = document.getElementById("scroll2");
      } else if (this.type == 1) {
        //活动页面
        dom = document.getElementById("scroll1");
      }
      if (type == 1) {
        // document.querySelector("#ttqd").scrollIntoView({
        //   behavior: "smooth"
        // });
        if (this.isUle) {
          dom.scrollTop = document.getElementById("ttqd").offsetTop - 45;
        } else {
          dom.scrollTop = document.getElementById("ttqd").offsetTop - 85;
        }
      } else {
        // document.querySelector("#cjfl").scrollIntoView({
        //   behavior: "smooth"
        // });
        // if (this.isUle) {
        //   dom.scrollTop = document.getElementById("cjfl").offsetTop - 45;
        // } else {
        //   dom.scrollTop = document.getElementById("cjfl").offsetTop - 85;
        // }
      }
    }
  }
};
</script>
<style lang="less" scoped>
/* 右边导航按钮 */
.box-fr {
  display: block;
  position: fixed;
  width: 0.51rem;
  height: 2.14rem;
  background: url("//i0.ulecdn.com/i/event/2019/0919/main/images/fr.png")
    no-repeat center 0.06rem;
  background-size: 100% 100%;
  top: 22%;
  right: 0;
  z-index: 15;
}
.fr-nav {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;
  z-index: -1;
  opacity: 0;
  display: block;
  transition: opacity 0.3s, z-index 0.3s;
  -webkit-transition: opacity 0.3s, z-index 0.3s;
}
.fr-nav.fr-navshoe {
  opacity: 1;
  z-index: 9999;
}
.fr-nav-box {
  position: relative;
  width: 100%;
  max-width: 640px;
  height: 100%;
  margin: 0 auto;
}
.fr-nav-con {
  width: 2.8rem;
  background: url(//i0.ulecdn.com/i/event/2019/0919/main/images/frb.png)
    no-repeat center bottom;
  background-size: 100% 0.81rem;
  padding-bottom: 0.8rem;
  position: absolute;
  top: 54%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  right: -3.62rem;
  transition: right 1s;
  -webkit-transition: right 1s;
}
.fr-nav-con.fr-nav-conshow {
  right: 0.62rem;
}
.fr-nav-con .fr-nav-nav {
  box-sizing: border-box;
  width: 100%;
  background: url(//i0.ulecdn.com/i/event/2019/0919/main/images/frbg.png) repeat
    center top;
  background-size: 100% 0.66rem;
  padding: 0.66rem 0.16rem 0;
}
.fr-nav-con .fr-nav-nav .fr-nav-but {
  text-align: center;
  color: #fff;
  font-size: 0.26rem;
  width: 2.48rem;
  height: 0.57rem;
  background: url(//i0.ulecdn.com/i/event/2019/0919/main/images/fn-but.png)
    repeat center top;
  background-size: 100% 100%;
  line-height: 0.57rem;
  margin-top: 0.05rem;
}
.fr-nav-nav ul {
  width: 100%;
  margin-top: 0.03rem;
}
.fr-nav-nav ul li {
  width: 49.19%;
  height: 0.48rem;
  background-color: #fff;
  float: left;
  margin-bottom: 0.02rem;
}
.pinl li:nth-of-type(2n) {
  float: right;
}
.pinl li:nth-of-type(9),
.pinl li:nth-of-type(10) {
  width: 100%;
}
.fr-nav-nav ul li a {
  display: block;
  width: 100%;
  height: 100%;
  color: #df4e1b;
  line-height: 0.48rem;
  font-size: 0.24rem;
  text-align: center;
}
.fr-nav-nav ul.diqu li {
  float: right;
}
.fr-nav-nav ul.diqu li:nth-of-type(2n) {
  float: left;
}
.fr-nav-nav ul.diqu li:nth-of-type(1) {
  width: 100%;
}
.fr-nav-con h5 {
  position: absolute;
  width: 4.04rem;
  height: 3.38rem;
  background: url(//i0.ulecdn.com/i/event/2019/0919/main/images/frt.png) repeat
    center top;
  background-size: 100% 100%;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
  left: 50%;
  top: -2.56rem;
  z-index: 2;
}
.fr-nav-con i {
  width: 2.8rem;
  height: 1.59rem;
  position: absolute;
  z-index: 2;
  background: url(//i0.ulecdn.com/i/event/2019/0919/main/images/frred.png)
    no-repeat center top;
  background-size: 1.61rem 100%;
  left: 0;
  right: 0;
  bottom: -1.29rem;
  display: block;
  -webkit-transform-origin: 50% 0;
  transform-origin: 50% 0;
  animation-duration: 4s;
  -webkit-animation-duration: 4s;
  animation-timing-function: ease;
  -webkit-animation-timing-function: ease;
  -webkit-animation-name: rotateto;
  animation-name: rotateto;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
}
.fr-nav-con .shoufr {
  width: 0.52rem;
  height: 2.14rem;
  position: absolute;
  background: url(//i0.ulecdn.com/i/event/2019/0919/main/images/frq.png) repeat
    center top;
  background-size: 100% 100%;
  top: 5%;
  left: -0.52rem;
}
@-webkit-keyframes rotateto {
  0% {
    -webkit-transform: rotate(24deg);
    transform: rotate(24deg);
  }
  50% {
    -webkit-transform: rotate(-24deg);
    transform: rotate(-24deg);
  }
  100% {
    -webkit-transform: rotate(24deg);
    transform: rotate(24deg);
  }
}

@keyframes rotateto {
  0% {
    -webkit-transform: rotate(24deg);
    transform: rotate(24deg);
  }
  50% {
    -webkit-transform: rotate(-24deg);
    transform: rotate(-24deg);
  }
  100% {
    -webkit-transform: rotate(24deg);
    transform: rotate(24deg);
  }
}
/*  头图动画  */
.grainsWrapper {
  position: absolute;
  top: 1.6rem;
  right: 0.6rem;
  width: 1.4rem;
  z-index: 2;
}
#grainsWrapper1 {
  left: 0.6rem;
  -webkit-transform: rotateY(180deg);
}
/*麦穗css*/
.grain {
  position: absolute;
  -webkit-transform-origin: top left;
}
.grainsWrapper img.grain:nth-of-type(2) {
  left: 0.1rem;
  top: 1.2rem;
}
.grainsWrapper img.grain:nth-of-type(3) {
  left: -0.2rem;
  top: 2.15rem;
}
.grainsWrapper img.grain:nth-of-type(4) {
  left: -0.7rem;
  top: 2.25rem;
}
/*红包射出css*/
#redPacketsWrapper {
  position: absolute;
  z-index: 2;
  width: 100%;
  top: 2.3rem;
}
.redPacket {
  width: 0.8rem;
  position: absolute;
  -webkit-transform: rotate(-50deg);
  -webkit-animation-fill-mode: forwards;
}
/*大蒜辣椒*/
.others {
  position: absolute;
  z-index: 2;
  width: 1.2rem !important;
  top: 4.3rem;
  -webkit-transform-origin: top right;
}
#redPacketsWrapper div.redPacket:nth-of-type(3),
#redPacketsWrapper div.redPacket:nth-of-type(4) {
  -webkit-transform: rotate(30deg);
}
#redPacketsWrapper div.redPacket:nth-of-type(1) {
  left: 3.5rem;
  top: 0;
}
#redPacketsWrapper div.redPacket:nth-of-type(2) {
  left: 18%;
  top: 45%;
}
#redPacketsWrapper div.redPacket:nth-of-type(3) {
  right: 28%;
  top: 28%;
}
#redPacketsWrapper div.redPacket:nth-of-type(4) {
  right: 25%;
  top: 48%;
}
/*麦穗摇晃*/
@-webkit-keyframes grains1Shake {
  50% {
    -webkit-transform: rotate(-6deg);
  }
}
@-webkit-keyframes grains2Shake {
  50% {
    -webkit-transform: rotate(-2deg);
  }
}
@-webkit-keyframes grains3Shake {
  50% {
    -webkit-transform: rotate(-5deg);
  }
}
@-webkit-keyframes redPacketShoot {
  90% {
    opacity: 0.3;
  }
  100% {
    opacity: 0;
    -webkit-transform: translateY(-350%);
  }
}
.grains1Shake {
  -webkit-animation: grains1Shake 6s linear infinite;
}
.grains2Shake {
  -webkit-animation: grains2Shake 6s ease-in-out infinite;
}
.grains3Shake {
  -webkit-animation: grains3Shake 6s ease-in-out infinite;
}
.grains4Shake {
  -webkit-animation: grains2Shake 6s ease-in-out infinite;
}
.redPacketShoot1 {
  -webkit-animation: redPacketShoot 1s 0.8s linear infinite;
}
.redPacketShoot2 {
  -webkit-animation: redPacketShoot 1s 0.4s linear infinite;
}
.redPacketShoot3 {
  -webkit-animation: redPacketShoot 1s 0.6s ease-in-out infinite;
}
.redPacketShoot4 {
  -webkit-animation: redPacketShoot 1s 0.2s linear infinite;
}
</style>



// WEBPACK FOOTER //
// src/components/common/sliderMenu.vue